import { fetchMFAPreference } from '@aws-amplify/auth';
import { send_request } from './Request';

export const MFA_COMPLIANT = 'compliant';
export const MFA_NEEDS_SETUP = 'needs_setup';
export const MFA_UNKNOWN = 'unknown';

export function isSoftwareTokenMfaEnabled(mfaPreference) {
  if (!mfaPreference) {
    return false;
  }

  const preferred = mfaPreference.preferred || mfaPreference.preferredMFA || '';
  const enabled = mfaPreference.enabled || mfaPreference.enabledMFATypes || [];
  const enabledTypes = Array.isArray(enabled) ? enabled : [enabled];
  const normalizedPreferred = String(preferred).toUpperCase();
  const normalizedEnabled = enabledTypes.map(type => String(type).toUpperCase());

  return (
    normalizedPreferred.includes('SOFTWARE_TOKEN_MFA') ||
    normalizedPreferred.includes('TOTP') ||
    normalizedEnabled.some(type => type.includes('SOFTWARE_TOKEN_MFA') || type.includes('TOTP'))
  );
}

/**
 * Resolves the caller's organization MFA enforcement state.
 *
 * Returns one of:
 * - MFA_COMPLIANT: enforcement is off, or the user already has a software token enrolled.
 * - MFA_NEEDS_SETUP: enforcement is on and the user has no software token enrolled.
 * - MFA_UNKNOWN: the policy or Cognito preference could not be determined.
 *
 * Callers decide how to treat MFA_UNKNOWN. The sign-in gate treats it as fail-closed
 * (block and force re-auth); session bootstrap treats it leniently to avoid logging
 * everyone out on a transient backend error.
 */
export async function checkMfaCompliance() {
  let policyResponse;
  try {
    policyResponse = await send_request('authz-service/mfa-enforcement', '', {}, 'GET');
  } catch (error) {
    return MFA_UNKNOWN;
  }

  const policyData =
    policyResponse && !(policyResponse instanceof Error) && !policyResponse.response
      ? policyResponse.data
      : null;

  if (!policyData) {
    return MFA_UNKNOWN;
  }

  if (!policyData.mfaEnforced) {
    return MFA_COMPLIANT;
  }

  try {
    const mfaPreference = await fetchMFAPreference();
    return isSoftwareTokenMfaEnabled(mfaPreference) ? MFA_COMPLIANT : MFA_NEEDS_SETUP;
  } catch (error) {
    return MFA_UNKNOWN;
  }
}
